import { Phone, MessageCircle, ArrowRight } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_chaitra-property-reg/artifacts/g8q2uj02_ChatGPT%20Image%20Mar%202%2C%202026%2C%2012_55_40%20AM.png" 
          alt="Bengaluru Cityscape"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-800/75 to-emerald-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          <h1 className="text-6xl md:text-8xl font-extrabold text-white mb-6 leading-tight drop-shadow-2xl">
            Trusted Property Registration & 
            <span className="block mt-2 bg-gradient-to-r from-amber-300 via-amber-400 to-yellow-400 bg-clip-text text-transparent"> Legal Documentation</span> Experts
          </h1>

          <div className="inline-block bg-amber-500/25 backdrop-blur-md border border-amber-400/40 rounded-full px-6 py-2.5 mb-8 shadow-lg">
            <span className="text-amber-300 font-bold text-base tracking-wide">20+ YEARS OF TRUSTED SERVICE</span>
          </div>
          
          <p className="text-2xl md:text-3xl text-white font-medium mb-10 leading-relaxed max-w-3xl drop-shadow-lg">
            Expert legal consultancy and seamless property registration services in Bengaluru. 
            Your trusted partner for accurate, compliant, and hassle-free documentation.
          </p>

          <div className="flex flex-wrap gap-4 mb-12">
            <a 
              href="tel:+918217026707"
              className="group bg-gradient-to-r from-emerald-600 to-emerald-700 text-white px-10 py-5 rounded-xl font-bold text-xl hover:from-emerald-700 hover:to-emerald-800 transition-all duration-300 shadow-2xl hover:shadow-emerald-500/50 hover:scale-105 flex items-center gap-3"
            >
              <Phone className="group-hover:rotate-12 transition-transform" size={26} />
              Call Now
            </a>
            
            <a 
              href="https://wa.me/918217026707"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white text-slate-800 px-10 py-5 rounded-xl font-bold text-xl hover:bg-gray-50 transition-all duration-300 shadow-2xl hover:scale-105 flex items-center gap-3"
            >
              <MessageCircle className="text-emerald-600 group-hover:scale-110 transition-transform" size={26} />
              Chat on WhatsApp
            </a>

            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="group border-2 border-white text-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-white hover:text-slate-800 transition-all duration-300 shadow-xl flex items-center gap-3"
            >
              Book Consultation
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={26} />
            </button>
          </div>

          {/* Trust indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8 border-t border-white/30">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-extrabold text-amber-300 mb-2 drop-shadow-lg">20+</div>
              <div className="text-white font-semibold text-base drop-shadow">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-extrabold text-amber-300 mb-2 drop-shadow-lg">50000+</div>
              <div className="text-white font-semibold text-base drop-shadow">Properties Registered</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-extrabold text-amber-300 mb-2 drop-shadow-lg">10000+</div>
              <div className="text-white font-semibold text-base drop-shadow">Happy Customers</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-extrabold text-amber-300 mb-2 drop-shadow-lg">100%</div>
              <div className="text-white font-semibold text-base drop-shadow">Legal Compliance</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
